export default {
  SET_APPEAL: (state, appeal) => { state.current = appeal },
}
